// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccordionController from "./accordion_controller";
application.register("accordion", AccordionController);

import AdvanceCheckboxController from "./advance_checkbox_controller";
application.register("advance-checkbox", AdvanceCheckboxController);

import CountdownController from "./countdown_controller";
application.register("countdown", CountdownController);

import CountdownCheckoutController from "./countdown_checkout_controller";
application.register("countdown-checkout", CountdownCheckoutController);

import CurrencyController from "./currency_controller";
application.register("currency", CurrencyController);

import StickyButtonController from "./sticky_button_controller";
application.register("sticky-button", StickyButtonController);

import FlashMessageController from "./flash_message_controller";
application.register("flash-message", FlashMessageController);

import PhoneController from "./phone_controller";
application.register("phone", PhoneController);

import AddressController from "./address_controller";
application.register("address", AddressController);

import DocumentController from "./checkout/document_controller";
application.register("checkout-document", DocumentController);

import EmailController from "./checkout/email_controller";
application.register("checkout-email", EmailController);

import BumpToggleController from "./checkout/bump_toggle_controller";
application.register("checkout-bump-toggle", BumpToggleController);

import ConfettiController from "./confetti_controller";
application.register("confetti", ConfettiController);

import DrawAsideController from "./manage/draw_aside_controller";
application.register("manage--draw-aside", DrawAsideController);

import DropdownController from "./manage/dropdown_controller";
application.register("manage--dropdown", DropdownController);

import EmojiPickerController from "./manage/emoji_picker_controller";
application.register("manage--emoji-picker", EmojiPickerController);

import AsideNavCollapsibleController from "./manage/aside_nav_collapsible_controller";
application.register("manage--aside-nav-collapsible", AsideNavCollapsibleController);

import StripePaymentController from "./stripe_payment_controller";
application.register("stripe-payment", StripePaymentController);

import StripeThreeDsController from "./stripe_three_ds_controller";
application.register("stripe-three-ds", StripeThreeDsController);

import StripeConfirmPaymentController from "./stripe_confirm_payment_controller";
application.register("stripe-confirm-payment", StripeConfirmPaymentController);

import CheckoutFormController from "./showcase/checkout_form_controller";
application.register("showcase--checkout-form", CheckoutFormController);

import ModalController from "./manage/modal_controller";
application.register("manage--modal", ModalController);

import FrameLoaderController from "./manage/frame_loader_controller";
application.register("manage--frame-loader", FrameLoaderController);

import CopyLinkController from "./manage/copy_link_controller";
application.register("manage--copy-link", CopyLinkController);

import LazyImageController from "./manage/lazy_image_controller";
application.register("manage--lazy-image", LazyImageController);

import FileUploadController from "./manage/file_upload_controller";
application.register("manage--file-upload", FileUploadController);

import ScheduleNavController from "./manage/schedule_nav_controller";
application.register("manage--schedule-nav", ScheduleNavController);

import ProductScheduleController from "./manage/product_schedule_controller";
application.register("manage--product-schedule", ProductScheduleController);

import ProductCoachingController from "./manage/product_coaching_controller";
application.register("manage--product-coaching", ProductCoachingController);

import ImagePreviewController from "./manage/image_preview_controller";
application.register("manage--image-preview", ImagePreviewController);

import BookingConfigController from "./manage/booking_config_controller";
application.register("manage--booking-config", BookingConfigController);

import WhenSlotsController from "./manage/when_slots_controller";
application.register("manage--when-slots", WhenSlotsController);

import VodUploadController from "./manage/vod_upload_controller";
application.register("manage--vod-upload", VodUploadController);

import MsAudioPlayerController from "./manage/ms_audio_player_controller";
application.register("manage--ms-audio-player", MsAudioPlayerController);

import MediaUploadController from "./manage/media_upload_controller";
application.register("manage--media-upload", MediaUploadController);

import SortableController from "./manage/sortable_controller";
application.register("manage--sortable", SortableController);

import InlineEditController from "./manage/inline_edit_controller";
application.register("manage--inline-edit", InlineEditController);

import OutlineActionsController from "./manage/outline_actions_controller";
application.register("manage--outline-actions", OutlineActionsController);

import AdvancedPlansController from "./manage/advanced_plans_controller";
application.register("manage--advanced-plans", AdvancedPlansController);

import RsvpModalityController from "./manage/rsvp_modality_controller";
application.register("manage--rsvp-modality", RsvpModalityController);

import GoogleMapController from "./manage/google_map_controller";
application.register("manage--google-map", GoogleMapController);

import CourseAccordionController from "./manage/course_accordion_controller";
application.register("manage--course-accordion", CourseAccordionController);

import CommentRepliesController from "./manage/comment_replies_controller";
application.register("manage--comment-replies", CommentRepliesController);

import PollFrameController from "./manage/poll_frame_controller";
application.register("manage--poll-frame", PollFrameController);



import ToggleFieldController from "./manage/toggle_field_controller";
application.register("manage--toggle-field", ToggleFieldController);

import MultiCurrencyController from "./manage/multi_currency_controller";
application.register("manage--multi-currency", MultiCurrencyController);

import NumberFormatController from "./manage/number_format_controller";
application.register("manage--number-format", NumberFormatController);

import PlanConfigController from "./manage/plan_config_controller";
application.register("manage--plan-config", PlanConfigController);

import RadioToggleController from "./manage/radio_toggle_controller";
application.register("manage--radio-toggle", RadioToggleController);

import SelectToggleController from "./manage/select_toggle_controller";
application.register("manage--select-toggle", SelectToggleController);

import FormQuestionsController from "./manage/form_questions_controller";
application.register("manage--form-questions", FormQuestionsController);

import AppearanceController from "./manage/appearance_controller";
application.register("manage--appearance", AppearanceController);

import ColorPickerController from "./manage/color_picker_controller";
application.register("manage--color-picker", ColorPickerController);

import TomSelectController from "./manage/tom_select_controller";
application.register("manage--tom-select", TomSelectController);

import TiptapEditorController from "./manage/tiptap_editor_controller";
application.register("manage--tiptap-editor", TiptapEditorController);

import SearchDebounceController from "./manage/search_debounce_controller";
application.register("manage--search-debounce", SearchDebounceController);

import ListSearchController from "./manage/list_search_controller";
application.register("manage--list-search", ListSearchController);

import BatchSelectController from "./manage/batch_select_controller";
application.register("manage--batch-select", BatchSelectController);

import SalesChartController from "./manage/sales_chart_controller";
application.register("manage--sales-chart", SalesChartController);

import AttendanceFrequencyChartController from "./manage/attendance/frequency_chart_controller";
application.register("manage--attendance--frequency-chart", AttendanceFrequencyChartController);

import AttendanceDailyChartController from "./manage/attendance/daily_chart_controller";
application.register("manage--attendance--daily-chart", AttendanceDailyChartController);

import AttendanceHeatmapChartController from "./manage/attendance/heatmap_chart_controller";
application.register("manage--attendance--heatmap-chart", AttendanceHeatmapChartController);

import MenuNavEditController from "./manage/menu_nav_edit_controller";
application.register("manage--menu-nav-edit", MenuNavEditController);

import MenuFeedFormController from "./manage/menu_feed_form_controller";
application.register("manage--menu-feed-form", MenuFeedFormController);

import DiscountFormController from "./manage/discount_form_controller";
application.register("manage--discount-form", DiscountFormController);

import NotificationToggleController from "./manage/notification_toggle_controller";
application.register("manage--notification-toggle", NotificationToggleController);

import PlacesSearchController from "./manage/places_search_controller";
application.register("manage--places-search", PlacesSearchController);

import DevRoleSelectorController from "./manage/dev_role_selector_controller";
application.register("manage--dev-role-selector", DevRoleSelectorController);

import EditorDeviceController from "./manage/editor_device_controller";
application.register("manage--editor-device", EditorDeviceController);

import EditorColorPickerController from "./manage/editor_color_picker_controller";
application.register("manage--editor-color-picker", EditorColorPickerController);

import EditorSelectionController from "./manage/editor_selection_controller";
application.register("manage--editor-selection", EditorSelectionController);

import EditorDraftStoreController from "./manage/editor_draft_store_controller";
application.register("manage--editor-draft-store", EditorDraftStoreController);

import FormAutoSubmitController from "./manage/form_auto_submit_controller";
application.register("manage--form-auto-submit", FormAutoSubmitController);

import GoogleCalendarConfigController from "./manage/integrations/google_calendar_config_controller";
application.register("manage--google-calendar-config", GoogleCalendarConfigController);

import OpenfacturaStepController from "./manage/integrations/openfactura_step_controller";
application.register("manage--integrations--openfactura-step", OpenfacturaStepController);

import SiiWizardController from "./manage/integrations/sii_wizard_controller";
application.register("manage--integrations--sii-wizard", SiiWizardController);

import AdminPagesWizardController from "./manage/admin/pages_wizard_controller";
application.register("manage--admin--pages-wizard", AdminPagesWizardController);

import AdminPagesIconSelectorController from "./manage/admin/pages/icon_selector_controller";
application.register("manage--admin--pages--icon-selector", AdminPagesIconSelectorController);

import StripeCardFormController from "./stripe_card_form_controller";
application.register("stripe-card-form", StripeCardFormController);

import BillingCancelFormController from "./manage/billing_cancel_form_controller";
application.register("manage--billing-cancel-form", BillingCancelFormController);

import BillingExtendModalController from "./manage/billing_extend_modal_controller";
application.register("manage--billing-extend-modal", BillingExtendModalController);

import SaleBillingFormController from "./manage/sale_billing_form_controller";
application.register("manage--sale-billing-form", SaleBillingFormController);

import AutoClickController from "./manage/auto_click_controller";
application.register("manage--auto-click", AutoClickController);

import CoachingTabsController from "./manage/coaching_tabs_controller";
application.register("manage--coaching-tabs", CoachingTabsController);

import BookingsCountdownController from "./manage/bookings/countdown_controller";
application.register("manage--bookings--countdown", BookingsCountdownController);

import OnboardingUserFormController from "./onboarding/user_form_controller";
application.register("onboarding--user-form", OnboardingUserFormController);

import OnboardingPaymentController from "./onboarding/payment_controller";
application.register("onboarding--payment", OnboardingPaymentController);

import AutodmKeywordsController from "./manage/autodm/keywords_controller";
application.register("manage--autodm--keywords", AutodmKeywordsController);

import AutodmFormController from "./manage/autodm/form_controller";
application.register("manage--autodm--form", AutodmFormController);

import AutodmPostsModalController from "./manage/autodm/posts_modal_controller";
application.register("manage--autodm--posts-modal", AutodmPostsModalController);

import SharedConfettiFallController from "./shared/confetti_fall_controller";
application.register("shared--confetti-fall", SharedConfettiFallController);

import CumulativeRadioController from "./manage/cumulative_radio_controller";
application.register("manage--cumulative-radio", CumulativeRadioController);

import ImageUrlUploadController from "./manage/image_url_upload_controller";
application.register("manage--image-url-upload", ImageUrlUploadController);

import ShowcaseInlineTiptapEditorController from "./showcase/inline_tiptap_editor_controller";
application.register("showcase--inline-tiptap-editor", ShowcaseInlineTiptapEditorController);

import ShowcaseMediaGalleryController from "./showcase/media_gallery_controller";
application.register("showcase--media-gallery", ShowcaseMediaGalleryController);
